import { Field } from './index';

const checkValidation = (formData) => {
  const errors: any = [];
  if (!formData) return errors;

  // Check if the field has any validation besides being required
  Object.values(formData).map((field: Field, index) => {
    if (field.validation && field.value) {
      const isValid = field.validation(field.value);

      if (!isValid) {
        errors.push({ name: field.id, message: field.validationMessage ?? 'Something is wrong' });
      }
    }
  });

  return errors;
};

export default checkValidation;
